import * as React from "react";

const ProductListingsHazardous: React.FC = () => {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g fill="none" fillRule="evenodd" transform="translate(1 1)">
                <rect width="6" height="6" x="6.182" y="2.182" fill="#F9151E" transform="rotate(45 9.182 5.182)" />
                <rect width="6" height="6" x="2.182" y="6.182" fill="#008CDD" transform="rotate(45 5.182 9.182)" />
                <rect width="6" height="6" x="10.182" y="6.182" fill="#FED700" transform="rotate(45 13.182 9.182)" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M9,2.69118061e-13 L18,9 L9,18 L-1.0658141e-14,9 L9,2.69118061e-13 Z M8.964,10.025 L6.055,12.933 L9,15.8773757 L11.908,12.969 L8.964,10.025 Z M12.933,6.055 L10.025,8.964 L12.969,11.908 L15.8780277,8.999348 L12.933,6.055 Z M5.03,6.091 L2.12197234,8.999348 L4.995,11.873 L7.903,8.964 L5.03,6.091 Z M9,2.12132034 L6.091,5.03 L8.964,7.903 L11.873,4.994 L9,2.12132034 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(ProductListingsHazardous);
